import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_taken_legally_required_measures_to_protect_wrkrs_fr'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_taken_legally_required_measures_to_protect_wrkrs_fr',
  name: 'Has the facility taken legally required measures to protect workers from falls from heights?',
  description:
    'Consult applicable legal requirements. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.\r\r\n\r\r\nIf facility circumstances do not require protection from falls from heights, answer Not Applicable.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 4,
      slcpOptionName: 'ynna-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13860,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
